import { FC } from 'react';

import {
  Button,
  ButtonProps,
  Counter,
  Icon,
} from '@beeline/design-system-react/extracted-styles';
import { Icons } from '@beeline/design-tokens/js/iconfont';

import { TooltipWrapper } from '../TooltipWrapper/TooltipWrapper';

export interface FilterButtonProps
  extends Omit<ButtonProps, 'size' | 'startIcon'> {
  filtersCount: number;
  testId?: string;
}

export const FilterButton: FC<FilterButtonProps> = ({
  filtersCount,
  testId,
  ...rest
}) => {
  return (
    <TooltipWrapper title='Фильтры' dataTestId={`${testId}Tooltip`}>
      <Counter
        count={filtersCount ? filtersCount : undefined}
        data-testid={`${testId}Counter`}
      >
        <Button
          size='medium'
          startIcon={<Icon iconName={Icons.Filter} />}
          {...rest}
          data-testid={testId}
        />
      </Counter>
    </TooltipWrapper>
  );
};
